import React, { useEffect, useState } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import kampudecte from "../../Assests_Url/Kampus Ueducate_new.png";
import ksmaccudecat from "../../Assests_Url/Ksmacc Ueducate_new.png";
import katboueduc from "../../Assests_Url/Katbook Ueducate_new.png";
import katbooksmall from "../../Assests_Url/katbooksmall.png";
import pen from "../../Assests_Url/pen.svg";
import lock from "../../Assests_Url/ic_round-lock.svg";
import graduation from "../../Assests_Url/stash_graduation-cap-solid.svg";
import university from "../../Assests_Url/fa_university.svg";
import studen from "../../Assests_Url/studen.png";
import Teachers from "../../Assests_Url/teach.png";
import Schools from "../../Assests_Url/schoo.png";

const UEducate = ({
  RoutesClick,
  NcertClick,
  selectedLang,
  setSelectedLang,
  allCountries
}) => {
  const [registerModal, setRegisterModal] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [activeTabHeader, setActiveTabHeader] = React.useState("UEducate");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);
  const [AdminregisterModal, setAdminregisterModal] = useState(false);
  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get("lang") || "en";

  return (
    <div>
      <Header
        activeTab={activeTabHeader}
        handleTabClick={handleTabClickHeader}
        studentregisterModal={studentregisterModal}
        setStudentRegisterModal={setStudentRegisterModal}
        ParentregisterModal={ParentregisterModal}
        setParentRegisterModal={setParentRegisterModal}
        TeacherregisterModal={TeacherregisterModal}
        setTeacherregisterModal={setTeacherregisterModal}
        AdminregisterModal={AdminregisterModal}
        setAdminregisterModal={setAdminregisterModal}
        registerModal={registerModal}
        setRegisterModal={setRegisterModal}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
        selectedLang={selectedLang}
        setSelectedLang={setSelectedLang}
        allCountries={allCountries}
      />
      <div>
        <div className="bannerImgUeducate">
          <div className="bannerOverlayUE">
            <div className="ue1">
              {/* “UEducate — Powering the Future of Learning” */}
              {lang === "en"
                ? "“UEducate — Powering the Future of Learning”"
                : lang === "hi"
                ? "“यूएजुकेट - सीखने के भविष्य को सशक्त बनाना”"
                : null}
            </div>

            <div className="ue2">
              {/* “We blend content, technology, and pedagogy to create joyful,
              inclusive, and intelligent learning ecosystems.” */}
              {lang === "en"
                ? "“We blend content, technology, and pedagogy to create joyful, inclusive, and intelligent learning ecosystems.”"
                : lang === "hi"
                ? "“हम आनंददायक, समावेशी और बुद्धिमान शिक्षण पारिस्थितिकी तंत्र बनाने के लिए सामग्री, प्रौद्योगिकी और शिक्षा शास्त्र का मिश्रण करते हैं।”"
                : null}
            </div>

            <div className="ueducatregbutt">
              {!localStorage.getItem("token") && (
                <button
                  className="registerBtn mt-4"
                  onClick={() => {
                    setRegisterModal(!registerModal);
                  }}
                >
                  {/* Register now &nbsp; &rarr; */}
                  {lang === "en"
                    ? "Register now"
                    : lang === "hi"
                    ? "अभी पंजीकरण करें"
                    : null}{" "}
                  &nbsp; &rarr;
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="padthree">
          <div className="ue3">
            {/* Our Story */}
            {lang === "en" ? "Our Story" : lang === "hi" ? "हमारी कहानी" : null}
          </div>

          <div className="ue4">
            {/* U-Educate was founded with a simple belief:{" "} */}
            {lang === "en"
              ? "UEducate was founded with a simple belief: "
              : lang === "hi"
              ? "यूएजुकेट की स्थापना एक साधारण विश्वास के साथ की गई थी: "
              : null}
            <span className="ue5">
              {/* Education must evolve with the Learner. */}
              {lang === "en"
                ? "Education must evolve with the Learner. "
                : lang === "hi"
                ? "शिक्षा को शिक्षार्थी के साथ विकसित होना चाहिए। "
                : null}
            </span>
            {/* Traditional textbooks served generations well, but today’s students
            need more —{" "} */}
            {lang === "en"
              ? "Traditional textbooks served generations well, but today’s students need more — "
              : lang === "hi"
              ? "पारंपरिक पाठ्यपुस्तकों ने पीढ़ियों की अच्छी सेवा की है, लेकिन आज के छात्रों को अधिक "
              : null}
            <span className="ue5">
              {/* Interactive, Engaging, and Personalised Tools */}
              {lang === "en"
                ? "Interactive, Engaging, and Personalised Tools."
                : lang === "hi"
                ? "इंटरैक्टिव, आकर्षक और वैयक्तिकृत टूल की आवश्यकता है।"
                : null}
            </span>
          </div>
          <div className="ue4">
            {/* From a small team of innovators to partnerships with{" "}
            <span className="ue5">NCERT, DIKSHA, and state governments</span>,
            UEducate has grown into a{" "}
            <span className="ue5">trusted national EdTech partner</span>,
            impacting{" "}
            <span className="ue5">
              thousands of schools and lakhs of students.
            </span> */}
            {lang === "en" ? (
              <>
                From a small team of innovators to partnerships with{" "}
                <span className="ue5">
                  DIKSHA, and state governments
                </span>
                , UEducate has grown into a{" "}
                <span className="ue5">trusted national EdTech partner</span>,
                impacting{" "}
                <span className="ue5">
                  thousands of schools and lakhs of students.
                </span>
              </>
            ) : lang === "hi" ? (
              <>
                नवप्रवर्तकों की एक छोटी टीम से लेकर{" "}
                <span className="ue5">एनसीईआरटी, दीक्षा और राज्य सरकारों</span>{" "}
                के साथ साझेदारी तक, यूएजुकेट एक{" "}
                <span className="ue5">विश्वसनीय राष्ट्रीय एडटेक भागीदार </span>
                के रूप में विकसित हुआ है,{" "}
                <span className="ue5">
                  जो हजारों स्कूलों और लाखों छात्रों
                </span>{" "}
                को प्रभावित कर रहा है।
              </>
            ) : null}
          </div>
        </div>

        <div className="padtopbotUeduc">
          <div className="ue6">
            <div className="ue7">
              {/* Our Vision */}
              {lang === "en"
                ? "Our Vision"
                : lang === "hi"
                ? "हमारा विज़न"
                : null}
            </div>
            <div className="ue8">
              {/* To make education joyful, inclusive, and future-ready for every
              learner. */}
              {lang === "en"
                ? "To make education joyful, inclusive, and future-ready for every learner."
                : lang === "hi"
                ? "शिक्षा को प्रत्येक शिक्षार्थी के लिए आनंददायक, समावेशी और भविष्य के लिए तैयार बनाना।"
                : null}
            </div>
            <div className="ue7 pt-3">
              {/* Our Mission */}
              {lang === "en"
                ? "Our Mission"
                : lang === "hi"
                ? "हमारा मिशन"
                : null}
            </div>
            <div className="ue8">
              {/* Transform static textbooks into smart, interactive learning
              ecosystems. */}
              {lang === "en"
                ? "Transform static textbooks into smart, interactive learning ecosystems."
                : lang === "hi"
                ? "स्थिर पाठ्यपुस्तकों को स्मार्ट, इंटरैक्टिव शिक्षण पारिस्थितिकी तंत्र में बदलना।"
                : null}
            </div>
            <div className="ue8">
              {/* Empower teachers with time-saving, classroom-ready tools. */}
              {lang === "en"
                ? "Empower teachers with time-saving, classroom-ready tools."
                : lang === "hi"
                ? "शिक्षकों को समय बचाने वाले, कक्षा-तैयार उपकरणों से सशक्त बनाना।"
                : null}
            </div>
            <div className="ue8">
              {/* Provide parents with transparent insights into progress. */}
              {lang === "en"
                ? "Provide parents with transparent insights into progress."
                : lang === "hi"
                ? "अभिभावकों को प्रगति के बारे में पारदर्शी जानकारी प्रदान करना।"
                : null}
            </div>
            <div className="ue8">
              {/* Partner with governments, boards, and schools to scale education
              innovation nationwide. */}
              {lang === "en"
                ? "Partner with governments, boards, and schools to scale education innovation nationwide."
                : lang === "hi"
                ? "देश भर में शिक्षा नवाचार को बढ़ावा देने के लिए सरकारों, बोर्डों और स्कूलों के साथ साझेदारी करना।"
                : null}
            </div>
          </div>
        </div>

        <div className="borderBotts" />

        <div className="padfivethree">
          <div className="ue9">
            {/* What We Do? */}
            {lang === "en"
              ? "What We Do ?"
              : lang === "hi"
              ? "हम क्या करते हैं?"
              : null}
          </div>
          <div className="kat-card">
            <div className="d-flex flex-column justify-content-center gap15">
              <div>
                <img src={kampudecte} alt="" />
              </div>
              <div className="ue10">
                {/* A School Information & Learning Management System for academics,
                assessments, attendance, and library management. */}
                {lang === "en"
                  ? "A School Information & Learning Management System for academics, assessments, attendance, and library management."
                  : lang === "hi"
                  ? "शैक्षणिक, मूल्यांकन, उपस्थिति और पुस्तकालय प्रबंधन के लिए एक स्कूल सूचना एवं शिक्षण प्रबंधन प्रणाली।"
                  : null}
              </div>
            </div>
            <div className="divider"></div>
            <div className="d-flex flex-column justify-content-center gap15">
              <div>
                <img src={katboueduc} alt="" />
              </div>
              <div className="ue10">
                {/* NCERT’s next-generation digital textbooks with audio, video,
                AR/VR, practice tools, and analytics. */}
                {lang === "en"
                  ? "NCERT’s next-generation digital textbooks with audio, video, AR/VR, practice tools, and analytics."
                  : lang === "hi"
                  ? "ऑडियो, वीडियो, AR/VR, अभ्यास उपकरण और विश्लेषण के साथ NCERT की अगली जनरेशन की डिजिटल पाठ्यपुस्तकें।"
                  : null}
              </div>
            </div>
            <div className="divider"></div>
            <div className="d-flex flex-column justify-content-center gap15">
              <div>
                <img src={ksmaccudecat} alt="" />
              </div>
              <div className="ue10">
                {/* A secure communication and collaboration platform for schools,
                teachers, students, and parents. */}
                {lang === "en"
                  ? "A secure communication and collaboration platform for schools, teachers, students, and parents."
                  : lang === "hi"
                  ? "स्कूलों, शिक्षकों, छात्रों और अभिभावकों के लिए एक सुरक्षित संचार और सहयोग मंच।"
                  : null}
              </div>
            </div>
          </div>
        </div>

        <div className="padtwetytwo">
          <div className="ue11">
            <span className="ue12">
              {/* AI & Analytics */}
              {lang === "en"
                ? "AI & Analytics"
                : lang === "hi"
                ? "AI और विश्लेषण"
                : null}
            </span>
            {/* — Smart search,
            translations, coverage reports, and performance dashboards for
            data-driven learning. */}
            {lang === "en"
              ? " — Smart search, translations, coverage reports, and performance dashboards for data-driven learning."
              : lang === "hi"
              ? " — डेटा संचालित शिक्षण के लिए स्मार्ट खोज, अनुवाद, कवरेज रिपोर्ट और प्रदर्शन डैशबोर्ड।"
              : null}
          </div>
        </div>

        <div className="borderBotts" />

        <div className="padfivethree20">
          <div className="ue13">
            {/* Global Vision */}
            {lang === "en"
              ? "Global Vision"
              : lang === "hi"
              ? "वैश्विक दृष्टिकोण"
              : null}
          </div>
          <div className="ue14">
            {/* While our roots are in India’s classrooms, our mission is global. */}
            {lang === "en"
              ? "While our roots are in India’s classrooms, our mission is global."
              : lang === "hi"
              ? "यद्यपि हमारी जड़ें भारत की कक्षाओं में हैं, हमारा मिशन वैश्विक है।"
              : null}
          </div>
          <div className="ue14">
            {/* We aim to expand U-Educate’s platforms to */}
            {lang === "en"
              ? "We aim to expand UEducate’s platforms to "
              : lang === "hi"
              ? "हमारा लक्ष्य यूएजुकेट के प्लेटफॉर्म को "
              : null}
            <span className="ue15">
              {/* International schools and developing nations, offering affordable,
              scalable, and inclusive solutions for the future of learning. */}
              {lang === "en"
                ? "International schools and developing nations, offering affordable, scalable, and inclusive solutions for the future of learning."
                : lang === "hi"
                ? "अंतर्राष्ट्रीय स्कूलों और विकासशील देशों तक विस्तारित करना है, तथा सीखने के भविष्य के लिए किफायती, स्केलेबल और समावेशी समाधान प्रदान करना है।"
                : null}
            </span>
          </div>
        </div>

        <div className="padfivethree20">
          <div className="ue13">
            {/* Our Solution */}
            {lang === "en"
              ? "Our Solution"
              : lang === "hi"
              ? "हमारा समाधान"
              : null}
          </div>
          <div className="ue14">
            {/* At UEducate, we believe in building  */}
            {lang === "en"
              ? "At UEducate, we believe in building "
              : lang === "hi"
              ? "यूएजुकेट में, हम शिक्षा के लिए "
              : null}
            <span className="ue15">
              {/* end-to-end digital ecosystems for education */}
              {lang === "en"
                ? "end-to-end digital ecosystems for education"
                : lang === "hi"
                ? "संपूर्ण डिजिटल पारिस्थितिकी तंत्र के निर्माण में विश्वास करते हैं "
                : null}
            </span>
            {/* —where */}
            {lang === "en" ? "—where " : lang === "hi" ? "- जहां " : null}
            <span className="ue15">
              {/* content, technology, and communication */}
              {lang === "en"
                ? "content, technology, and communication "
                : lang === "hi"
                ? "विषय-वस्तु, प्रौद्योगिकी और संचार "
                : null}
            </span>{" "}
            {/* come together to transform learning. */}
            {lang === "en"
              ? "come together to transform learning."
              : lang === "hi"
              ? "मिलकर सीखने में परिवर्तन लाते हैं।"
              : null}
          </div>
          <div className="ue14">
            {/* Our solutions are designed to empower{" "} */}
            {lang === "en"
              ? "Our solutions are designed to empower "
              : lang === "hi"
              ? "हमारे समाधान "
              : null}
            <span className="ue15">
              {/* students, teachers, schools, and parents */}
              {lang === "en"
                ? "students, teachers, schools, and parents "
                : lang === "hi"
                ? "छात्रों, शिक्षकों, स्कूलों और अभिभावकों "
                : null}
            </span>{" "}
            {/* with tools that are{" "} */}
            {lang === "en"
              ? "with tools that are "
              : lang === "hi"
              ? "को ऐसे उपकरणों से सशक्त बनाने के लिए डिज़ाइन किए गए हैं जो "
              : null}
            <span className="ue15">
              {/* interactive, inclusive, and future-ready */}
              {lang === "en"
                ? "interactive, inclusive, and future-ready."
                : lang === "hi"
                ? "इंटरैक्टिव, समावेशी और भविष्य के लिए तैयार हैं।"
                : null}
            </span>
          </div>
        </div>

        <div className="padfivethree20">
          <div className="ue16">
            {/* Key Offerings */}
            {lang === "en"
              ? "Key Offerings"
              : lang === "hi"
              ? "प्रमुख पेशकशें"
              : null}
          </div>

          <div className="py-3">
            <div className="ue17">
              <img
                src={katbooksmall}
                alt="kampus"
                className="maritoo pensize"
              />
              {/* KATBOOK */}
              {lang === "en" ? "KATBOOK" : lang === "hi" ? "कैटबुक" : null}
            </div>

            <div className="ue18 padd10">
              {/* NCERT’s next-generation digital textbook platform with audio,
              video, 3D/AR/VR, translations, exercises, and analytics. */}
              {lang === "en"
                ? "NCERT’s next-generation digital textbook platform with audio, video, 3D/AR/VR, translations, exercises, and analytics."
                : lang === "hi"
                ? "ऑडियो, वीडियो, 3D/AR/VR, अनुवाद, अभ्यास और विश्लेषण के साथ NCERT का अगली पीढ़ी का डिजिटल पाठ्यपुस्तक प्लेटफ़ॉर्म।"
                : null}
            </div>
          </div>

          <div className="py-3">
            <div className="ue17">
              <img src={pen} alt="kampus" className="maritoo pensize" />
              {/* KAMPUS */}
              {lang === "en" ? "KAMPUS" : lang === "hi" ? "कैम्पस" : null}
            </div>

            <div className="ue18 padd10">
              {/* Smart School Information System (SIS) for managing academics,
              administration, finance, and student records. */}
              {lang === "en"
                ? "Smart School Information System (SIS) for managing academics, administration, finance, and student records."
                : lang === "hi"
                ? "शैक्षणिक, प्रशासन, वित्त और छात्र रिकॉर्ड के प्रबंधन के लिए स्मार्ट स्कूल सूचना प्रणाली (SIS)।"
                : null}
            </div>
          </div>

          <div className="py-3">
            <div className="ue17">
              <img src={lock} alt="kampus" className="maritoo pensize" />
              {/* KSMACC */}
              {lang === "en" ? "KSMACC" : lang === "hi" ? "केएसएमएसीसी" : null}
            </div>

            <div className="ue18 padd10">
              {/* A secure communication platform for schools, ensuring safe and
              transparent parent–teacher engagement. */}
              {lang === "en"
                ? "A secure communication platform for schools, ensuring safe and transparent parent–teacher engagement."
                : lang === "hi"
                ? "स्कूलों के लिए एक सुरक्षित संचार प्लेटफ़ॉर्म, जो सुरक्षित और पारदर्शी अभिभावक-शिक्षक जुड़ाव सुनिश्चित करता है।"
                : null}
            </div>
          </div>

          <div className="py-3">
            <div className="ue17">
              <img src={graduation} alt="kampus" className="maritoo pensize" />
              {/* LMS (Learning Management System) */}
              {lang === "en"
                ? "LMS (Learning Management System)"
                : lang === "hi"
                ? "एलएमएस (लर्निंग मैनेजमेंट सिस्टम)"
                : null}
            </div>

            <div className="ue18 padd10">
              {/* A flexible digital classroom solution for course delivery,
              assignments, and assessments. */}
              {lang === "en"
                ? "A flexible digital classroom solution for course delivery, assignments, and assessments."
                : lang === "hi"
                ? "पाठ्यक्रम वितरण, असाइनमेंट और मूल्यांकन के लिए एक लचीला डिजिटल कक्षा समाधान।"
                : null}
            </div>
          </div>

          <div className="py-3">
            <div className="ue17">
              <img src={university} alt="kampus" className="maritoo pensize" />
              {/* University & Vocational Platforms */}
              {lang === "en"
                ? "University & Vocational Platforms"
                : lang === "hi"
                ? "विश्वविद्यालय और व्यावसायिक प्लेटफ़ॉर्म"
                : null}
            </div>

            <div className="ue18 padd10">
              {/* Scalable solutions for higher education and skill-based training. */}
              {lang === "en"
                ? "Scalable solutions for higher education and skill-based training."
                : lang === "hi"
                ? "उच्च शिक्षा और कौशल-आधारित प्रशिक्षण के लिए स्केलेबल समाधान।"
                : null}
            </div>
          </div>
        </div>

        <div className="padfivethree20">
          <div className="ue16 solution-title">
            {/* Why our Solution? */}
            {lang === "en"
              ? "Why our Solution ?"
              : lang === "hi"
              ? "हमारा समाधान क्यों ?"
              : null}
          </div>

          <div className="solution-grid">
            <div className="solution-card">
              {" "}
              <div className="solution-image-wrapper">
                {" "}
                <img
                  src={studen}
                  alt="For Students"
                  className="solution-image"
                />
                <div className="solution-image-text">
                  {/* For Students */}
                  {lang === "en"
                    ? "For Students"
                    : lang === "hi"
                    ? "छात्रों के लिए"
                    : null}
                </div>
                 {" "}
              </div>{" "}
              <div className="solution-content">
                {" "}
                <div className="solution-description">
                  {/* Joyful, interactive, and personalised learning */}
                  {lang === "en"
                    ? "Joyful, interactive, and personalised learning"
                    : lang === "hi"
                    ? "आनंददायक, इंटरैक्टिव और व्यक्तिगत शिक्षण।"
                    : null}
                </div>{" "}
              </div>
            </div>

            <div className="solution-card">
              {" "}
              <div className="solution-image-wrapper">
                {" "}
                <img
                  src={Teachers}
                  alt="For Students"
                  className="solution-image"
                />
                <div className="solution-image-text">
                  {/* For Teachers */}
                  {lang === "en"
                    ? "For Teachers"
                    : lang === "hi"
                    ? "शिक्षकों के लिए"
                    : null}
                </div>
                 {" "}
              </div>{" "}
              <div className="solution-content">
                <div className="solution-description">
                  {/* Smarter teaching tools and structured lesson support */}
                  {lang === "en"
                    ? "Smarter teaching tools and structured lesson support"
                    : lang === "hi"
                    ? "बेहतर शिक्षण उपकरण और संरचित पाठ सहायता।"
                    : null}
                </div>{" "}
              </div>
            </div>

            <div className="solution-card">
              {" "}
              <div className="solution-image-wrapper">
                {" "}
                <img
                  src={Schools}
                  alt="For Students"
                  className="solution-image"
                />
                <div className="solution-image-text">
                  {/* For Schools */}
                  {lang === "en"
                    ? "For Schools"
                    : lang === "hi"
                    ? "स्कूलों के लिए "
                    : null}
                </div>
                 {" "}
              </div>{" "}
              <div className="solution-content">
                <div className="solution-description">
                  {/* Simplified management, reduced paperwork, and real-time
                  analytics. */}
                  {lang === "en"
                    ? "Simplified management, reduced paperwork, and real-time analytics."
                    : lang === "hi"
                    ? "सरलीकृत प्रबंधन, कम कागजी कार्रवाई और वास्तविक समय विश्लेषण।"
                    : null}
                </div>{" "}
              </div>
            </div>

            {/* <div className="solution-card">
              {" "}
              <div className="solution-image-wrapper">
                {" "}
                <img
                  src={Parents}
                  alt="For Students"
                  className="solution-image"
                />
                <div className="solution-image-text">For Parents</div> {" "}
              </div>{" "}
              <div className="solution-content">
                <div className="solution-description">
                  Transparent, secure updates on their child’s progress.
                </div>{" "}
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <Footer
        setActiveTab={setActiveTabHeader}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
        selectedLang={selectedLang}
        setSelectedLang={setSelectedLang}
      />
    </div>
  );
};

export default UEducate;
